// extracted by mini-css-extract-plugin
export var icon = "_5c-1";
export var subtext = "_5c-0";